import { validateToken } from "./jwt";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");

// export const fetchHeaderFooterImageList = (payload) => {
//     return axiosInstance.get(EndPoints.HEADER_FOOTER.LIST, {
//         params: {
//             ...payload
//         }
//     });
// }

export const fetchHeaderFooterImageList = (payload) => {
  if (payload?.token) {
    if (validateToken(payload?.token)) {
      return axiosInstance.get(EndPoints.HEADER_FOOTER.LIST, {
        params: {
          zone_id: payload?.zone_id,
          is_active: payload?.is_active,
          created_by: payload?.created_by,
          header: payload?.header,
          footer: payload?.footer,
          watermark_image: payload?.watermark_image
        },
        headers: {
          Authorization: `Bearer ${payload?.token}`,
        },
      });
    }
    return;
  } else {
    return axiosInstance.get(EndPoints.HEADER_FOOTER.LIST, {
      params: {
        zone_id: payload?.zone_id,
        is_active: payload?.is_active,
        created_by: payload?.created_by,
        header: payload?.header,
        footer: payload?.footer,
        watermark_image: payload?.watermark_image
      },
    });
  }
};

export const createHeaderFooterImage = (payload) => {
  return axiosInstance.post(EndPoints.HEADER_FOOTER.CREATE, payload);
};

export const deleteHeaderFooterImage = (payload) => {
  return axiosInstance.delete(`${EndPoints.HEADER_FOOTER.DELETE}/${payload}`);
};